// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"6e4c89f9","249":"8ccd1eec","453":"2b9e5af2","554":"74f80bee","667":"035fc3a8","914":"1281fbb0"}[chunkId] + ".chunk.js";
};